import React from 'react';
import { CardImg } from 'reactstrap';

import Thumbnail from '../../generic/Thumbnail';
import { creativeShape } from '../../prop-types';

export default function CreativeCardImage({ creative, ...props }) {
  return (
    <CardImg
      tag={Thumbnail}
      id={creative.id}
      src={creative.thumbnailUrl}
      previewSrc={creative.fileUrl}
      title={creative.name}
      type={creative.fileType}
      {...props}
    />
  );
}

CreativeCardImage.propTypes = {
  creative: creativeShape.isRequired,
};
